import React, { useState } from 'react';
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { useLocation } from 'react-router-dom';

const PortalLayout = ({ children }) => {
    const [showNav, setShowNav] = useState(true);

    const location = useLocation()

    return (
        <>
            {['/login','/','/forgot-password'].includes(location.pathname.toLowerCase()) ? (
                children
            ) :
                <div className="flex flex-col h-screen">

                    <div className="w-full">
                        <Topbar showNav={showNav} setShowNav={setShowNav} />
                    </div>


                    <div className="flex flex-1 flex-col md:flex-row relative">

                        {/* Mobile overlay sidebar */}
                        <div className={`pb-10 transition-all duration-[400ms]`}> 
                            <div className="md:hidden">
                                {/* Backdrop */}
                                {showNav && (
                                    <div
                                        className="fixed inset-0 z-40 bg-black/40"
                                        onClick={() => setShowNav(false)}
                                    />
                                )}
                                {/* Drawer */}
                                <div className={`fixed z-50 inset-y-0 left-0 w-64 transform bg-black rounded-r-xl shadow-xl transition-transform duration-300 ${showNav ? 'translate-x-0' : '-translate-x-full'}`}>
                                    <Sidebar onClose={() => setShowNav(false)} />
                                </div>
                            </div>
                            {/* Desktop sidebar */}
                            <div className="hidden md:block">
                                <Sidebar />
                            </div>
                        </div>


                        <div className="flex-1  transition-all duration-[400ms] pl-0 md:pl-3 lg:pl-8">
                            <div className="flex h-full pb-10">{children}</div>
                        </div>
                    </div>
                </div>
            }
        </>

    );
};


export default PortalLayout;

